




































































































































































































































































































import BaseComponent from '@/core/base.component';
import Component from 'vue-class-component';
import toast from '../../../../resources/assets/js/services/toast.js';
import draggable from 'vuedraggable';
import {
  AmenityDto,
  BrandDto,
  DeliverySpaceDto,
  DeliverySpaceOptionDto,
  DeliverySpaceUpdateDto,
} from '../../../dto';

import {
  ATTACHMENT_REASON_TYPE,
  FileAttachmentDto,
} from '../../../services/shared/file-upload';
import AmenityService from '../../../services/amenity.service';
import BrandService from '../../../services/brand.service';
import DeliverySpaceService from '../../../services/delivery-space.service';
import FileUploadService from '../../../services/shared/file-upload/file-upload.service';
import { UPLOAD_TYPE } from '../../../services/shared/file-upload/file-upload.service';
import { YN, CONST_YN } from '@/common/interfaces';

@Component({
  name: 'DeliverySpaceUpdate',
  components: {
    draggable,
  },
})
export default class DeliverySpaceUpdate extends BaseComponent {
  private deliverySpaceDto = new DeliverySpaceDto();
  private deliverySpaceUpdateDto = new DeliverySpaceUpdateDto();
  private amenityList: AmenityDto[] = [];
  private amenityIds: number[] = [];
  private attachments: FileAttachmentDto[] = [];
  private brandList: BrandDto[] = [];
  private brandIds: number[] = [];
  private deliverySpaceOptionIds: number[] = [];
  private deliverySpaceOptionsList: DeliverySpaceOptionDto[] = [];
  private delYn: YN[] = [...CONST_YN];
  private showYn: YN[] = [...CONST_YN];
  private newImages: FileAttachmentDto[] = [];
  private uploadImages: FileAttachmentDto[] = [];
  private selectedImages = [];
  private changedImage = false;
  private dataLoading = false;
  private disabledYn = false;

  // get common facility list
  getSpaceOptions() {
    DeliverySpaceService.findSpaceOption().subscribe(res => {
      if (res) {
        this.deliverySpaceOptionsList = res.data;
      }
    });
  }

  // get kitchen facility list
  getAmenities() {
    AmenityService.findAmenities('kitchen-facility').subscribe(res => {
      if (res) {
        this.amenityList = res.data;
      }
    });
  }

  // add amenity array
  addAmenity(amenityId) {
    if (this.amenityIds.includes(parseInt(amenityId))) {
      const index = this.amenityIds.indexOf(parseInt(amenityId));
      if (index > -1) {
        this.amenityIds.splice(index, 1);
      }
    } else {
      this.amenityIds.unshift(parseInt(amenityId));
    }
  }

  // add delivery space option ids
  addDeliverySpaceOption(deliverySpaceOptionId) {
    if (this.deliverySpaceOptionIds.includes(parseInt(deliverySpaceOptionId))) {
      const index = this.deliverySpaceOptionIds.indexOf(
        parseInt(deliverySpaceOptionId),
      );
      if (index > -1) {
        this.deliverySpaceOptionIds.splice(index, 1);
      }
    } else {
      this.deliverySpaceOptionIds.unshift(parseInt(deliverySpaceOptionId));
    }
  }

  getQuantity(value) {
    if (value <= 0) {
      this.disabledYn = true;
      this.deliverySpaceUpdateDto.isOpenedYn = this.showYn[0];
    } else {
      this.disabledYn = false;
    }
  }

  // get brand
  getBrands() {
    BrandService.findForSelect().subscribe(res => {
      if (res) {
        this.brandList = res.data;
      }
    });
  }

  // add brand ids
  addBrand(brandId) {
    if (this.brandIds.includes(parseInt(brandId))) {
      const index = this.brandIds.indexOf(parseInt(brandId));
      if (index > -1) {
        this.brandIds.splice(index, 1);
      }
    } else {
      this.brandIds.unshift(parseInt(brandId));
    }
  }

  // find delivery space dto
  findDeliverySpaceDto(deliverySpace: DeliverySpaceDto) {
    this.deliverySpaceUpdateDto = deliverySpace;
    this.deliverySpaceUpdateDto.companyDistrictNo =
      deliverySpace.companyDistrictNo;

    this.amenityIds = deliverySpace.amenities.map(v => v.no);
    this.deliverySpaceOptionIds = deliverySpace.deliverySpaceOptions.map(
      v => v.no,
    );
    this.brandIds = deliverySpace.brands.map(v => v.no);

    this.selectedImages = deliverySpace.images;
    this.uploadImages = [...this.selectedImages];
  }

  // 이미지 업로드
  async upload(file: File[]) {
    this.dataLoading = true;
    const attachments = await FileUploadService.upload(
      UPLOAD_TYPE.DELIVERY_SPACE,
      file,
    );
    this.newImages = [];
    this.newImages.push(
      ...attachments.filter(
        fileUpload =>
          fileUpload.attachmentReasonType === ATTACHMENT_REASON_TYPE.SUCCESS,
      ),
    );

    this.dataLoading = false;
    this.changedImage = true;
  }

  // delete images
  deleteNewImages(image, index) {
    if (this.newImages.includes(image)) {
      index = this.newImages.indexOf(image);
      if (index > -1) {
        this.newImages.splice(index, 1);
      }
    }
  }

  deleteOldImages(image, index) {
    if (this.uploadImages.includes(image)) {
      index = this.uploadImages.indexOf(image);
      if (index > -1) {
        this.uploadImages.splice(index, 1);
      }
    }
  }

  // update delivery space dto
  updateDeliverySpace() {
    if (this.deliverySpaceOptionIds) {
      this.deliverySpaceUpdateDto.deliverySpaceOptionIds = this.deliverySpaceOptionIds;
    }
    if (this.amenityIds) {
      this.deliverySpaceUpdateDto.amenityIds = this.amenityIds;
    }

    if (this.brandIds) {
      this.deliverySpaceUpdateDto.brandIds = this.brandIds;
    }

    if (this.uploadImages && this.uploadImages.length > 0) {
      this.deliverySpaceUpdateDto.images = this.uploadImages;
      this.deliverySpaceUpdateDto.newImages = this.newImages;
    }
    if (
      this.uploadImages &&
      this.uploadImages.length < 1 &&
      this.newImages &&
      this.newImages.length > 0
    ) {
      this.deliverySpaceUpdateDto.images = [];
      this.deliverySpaceUpdateDto.newImages = this.newImages;
    }
    if (
      this.uploadImages &&
      this.uploadImages.length < 1 &&
      this.newImages &&
      this.newImages.length < 1
    ) {
      this.deliverySpaceUpdateDto.newImages = [];
      this.deliverySpaceUpdateDto.images = [];
    }

    if (
      this.uploadImages &&
      this.uploadImages.length === 0 &&
      this.newImages &&
      this.newImages.length > 0
    ) {
      this.deliverySpaceUpdateDto.images = this.newImages;
      this.deliverySpaceUpdateDto.newImages = [];
    }

    DeliverySpaceService.update(
      this.$route.params.id,
      this.deliverySpaceUpdateDto,
    ).subscribe(res => {
      if (res) {
        this.changedImage = false;
        this.$root.$emit('find_delivery_space');
        // DeliverySpaceService.findOne(this.$route.params.id).subscribe(res => {
        //   this.newImages = [];
        //   this.deliverySpaceUpdateDto = res.data;
        // });
        toast.success('수정완료');
      }
    });
  }

  // clear out delivery space update dto
  clearOutUpdateDto() {
    this.newImages = [];
    this.deliverySpaceUpdateDto = new DeliverySpaceUpdateDto();
  }

  created() {
    this.getAmenities();
    this.getSpaceOptions();
    this.getBrands();
  }

  mounted() {
    this.$root.$on('update_delivery_space', deliverySpaceDto => {
      this.findDeliverySpaceDto(deliverySpaceDto);
    });
  }
}
